import DogList from "./DogList"

// FEED RECEIVES AN OBJECT OF ALL DOG RECORDS FROM dog.js
// THEN RETURNS EACH RECORD AS A TABLE ROW

const DogFeed = ({ customers, onSelect }) => {
	return (
		<div className="table_container">
			<table>
				<thead>
					<tr>
						<th>Account</th>
						<th>Name</th>
						<th>Phone</th>
						<th>Address</th>
						<th>District</th>
						<th>Select</th>
					</tr>
				</thead>
				<tbody>
					{customers.map((customer, index) => (
						<DogList key={index} customer={customer} onSelect={onSelect} />
					))}
				</tbody>
			</table>
		</div>
	)
}

export default DogFeed
